import fp1np3d from "./img-04.jpg";
import fp1np2d from "./img-05.jpg";
import fp2np3d from "./img-17.jpg";
import fp2np2d from "./img-18.jpg";
import fpSuteren3d from "./img-26.jpg";
import fpSuteren2d from "./img-28.jpg";

const FLOOR_PLAN_KEYS = new Set([
  "./img-04.jpg",
  "./img-05.jpg",
  "./img-17.jpg",
  "./img-18.jpg",
  "./img-26.jpg",
  "./img-28.jpg",
]);

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const sorted = Object.entries(photoModules)
  .filter(([key]) => !FLOOR_PLAN_KEYS.has(key))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const branikPraha4Images: string[] = sorted;

export const branikPraha4FloorPlans: { image: string; label: string }[] = [
  { image: fp1np3d, label: "1. NP – 3D" },
  { image: fp2np3d, label: "2. NP – 3D" },
  { image: fpSuteren3d, label: "Suterén – 3D" },
  { image: fp1np2d, label: "1. NP – 2D" },
  { image: fp2np2d, label: "2. NP – 2D" },
  { image: fpSuteren2d, label: "Suterén – 2D" },
];
